<template>
    <div v-if="data" class="grid grid-cols gap-4">
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Razdelilnik stroškov:
                </p>
                <p v-if="data.sklic" class="break-all">
                    {{ data.sklic }}
                </p>
                <p v-else>
                    /
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Šifra plačnika:
                </p>
                <p v-if="data.partner_sifra || data.partner_naziv">
                    {{ data.partner_sifra }} {{ data.partner_naziv }}
                </p>
                <p v-else>
                    /
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Referenca za plačilo:
                </p>
                <p v-if="data.sklic" class="break-all">
                    {{ data.sklic }}
                </p>
                <p v-else>
                    /
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Datum valute:
                </p>
                <p>
                    {{ formatDate(data.datum_valute) }}
                </p>
            </div>
        </div>
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Št. računa za plačilo:
                </p>
                <p v-if="data.razdelilnik.trr_terjatve" class="break-all">
                    {{ data.razdelilnik.trr_terjatve }}
                </p>
                <p v-else>
                    /
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Datum dokumenta:
                </p>
                <p>
                    {{ formatDate(data.datum_dokumenta) }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold ">
                    DŠ/ID:
                </p>
                <p v-if="data.davcna" class="break-all">
                    {{ data.davcna }}
                </p>
                <p v-else>
                    /
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Obračun:
                </p>
                <p>
                    {{ data.obracun_vrsta }} {{ data.obracun_mesec }}/{{ data.obracun_leto }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from '@/libs/dayjs'

    export default {
        methods: {formatDate},
        props: {
            data: {
                type: Object,
                default: undefined
            }
        }
    }
</script>

<style scoped>
p {
  margin: 0;
}
.grid {
  display: grid;
}
.grid-cols {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
@media (min-width: 640px) {
  .grid-cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.gap-4 {
  gap: 1rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.font-bold {
  font-weight: 700;
}
</style>